'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('filingListController', function($rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {

    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.listCount = 0;
    $scope.docketsLoading = false;

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    /***********************/
    /***** Permissions *****/
    /***********************/

    /* F/E Permission Checking */
    $scope.userHasPermission = function(permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    /*******************************/
    /***** Major State Changes *****/
    /*******************************/

    $scope.$parent.prepareForFilingListFromParent = function() {
      $scope.listItems = [];
      $scope.docketsLoading = true;
    }

    $scope.$parent.loadDocketFilingListFromParent = function(docketsList, docketCount) {
      $scope.listItems = docketsList;
      $scope.listCount = docketCount;
      $scope.docketsLoading = false;
    }

    $scope.$parent.loadAdditionalDocketFilingFromParent = function(dockets) {
      for ( var i = 0; i < dockets.length; i++ ) {
        $scope.listItems.push(dockets[i]);
      }
    }

    /**************************************************/
    /***** Alert parent controller of ready state *****/
    /**************************************************/

    $scope.$parent.filingsChildControllerReady();

});



// WEBPACK FOOTER //
// ./src/controllers/filing/listController.js